(() => {
  const init = root => {
    if (!root || root.dataset.hwReady) return;
    root.dataset.hwReady = 'true';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const gallery = root.querySelector('[data-hw-gallery]');
    const thumbs = [...root.querySelectorAll('[data-hw-thumb]')];
    let active = 0;
    const fitGallery = () => {
      const image = gallery.querySelectorAll('.hw-gallery__image')[active];
      const width = Number(image?.getAttribute('width'));
      const height = Number(image?.getAttribute('height'));
      if (width > 0 && height > 0) gallery.style.setProperty('--hw-gallery-ratio', `${width} / ${height}`);
    };
    const updateGallery = () => {
      active = Math.max(0, Math.min(thumbs.length - 1, Math.round(gallery.scrollLeft / gallery.clientWidth)));
      fitGallery();
      thumbs.forEach((b,i) => b.setAttribute('aria-pressed', String(i === active)));
    };
    thumbs.forEach((b,i) => b.addEventListener('click', () => gallery.scrollTo({left:i * gallery.clientWidth,behavior:reduced.matches?'instant':'smooth'})));
    fitGallery();
    gallery.addEventListener('scroll', updateGallery, {passive:true});
    gallery.addEventListener('keydown', e => {
      if (!['ArrowLeft','ArrowRight'].includes(e.key)) return;
      e.preventDefault();
      thumbs[Math.max(0,Math.min(thumbs.length-1,active+(e.key==='ArrowRight'?1:-1)))].click();
    });
    const dialog = root.querySelector('[data-hw-dialog]');
    const zoomImage = root.querySelector('[data-hw-zoom-image]');
    root.querySelector('[data-hw-zoom]').addEventListener('click', () => {
      const img = gallery.querySelectorAll('img')[active];
      zoomImage.src = img.currentSrc || img.src;
      zoomImage.alt = img.alt;
      dialog.showModal();
    });
    root.querySelector('[data-hw-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
    const primary = root.querySelector('.buy-buttons-block button[type="submit"]');
    const trust = root.querySelector('[data-hw-purchase-trust]');
    const buttons = root.querySelector('.buy-buttons-block');
    if (buttons && trust) buttons.insertAdjacentElement('afterend', trust);
      const stickyButton = root.querySelector('[data-hw-buy]');
    if (primary) {
      stickyButton.addEventListener('click', () => {
        if (!primary.disabled) primary.click();
      });
      const sync = () => { stickyButton.disabled = primary.disabled; };
      new MutationObserver(sync).observe(primary,{attributes:true,attributeFilter:['disabled']});
      sync();
    }
    const stage = root.querySelector('[data-hw-scroll-scene]');
    const sceneImage = stage.querySelector('img');
    const reading = root.querySelector('[data-hw-reading]');
    const sentence = reading.textContent.trim();
    reading.setAttribute('aria-label', sentence);
    reading.textContent = '';
    const words = sentence.split(/\s+/).map(word => {
      const span=document.createElement('span');span.textContent=word;span.className='hw-reading-word';span.setAttribute('aria-hidden','true');reading.append(span);return span;
    });
    let queued = false;
    const update = () => {
      queued = false;
      if (!root.isConnected) return;
      const box = stage.getBoundingClientRect();
      if (box.bottom > 0 && box.top < innerHeight) {
        const progress = Math.max(0,Math.min(1,(innerHeight * .62 - box.top) / Math.max(1,box.height - innerHeight * .3)));
        words.forEach((span,i) => span.style.setProperty('--hw-word-opacity',reduced.matches?1:(.3+.7*Math.max(0,Math.min(1,(progress-i/words.length)*words.length*1.8)))));
        sceneImage.style.setProperty('--hw-scale',reduced.matches?1:1.07-.07*progress);
      }
    };
    const requestUpdate = () => {if(!queued){queued=true;requestAnimationFrame(update);}};
    document.addEventListener('scroll',requestUpdate,{passive:true,capture:true});
    window.addEventListener('resize',requestUpdate,{passive:true});
    reduced.addEventListener('change',requestUpdate);
    if ('IntersectionObserver' in window && !reduced.matches) {
      root.classList.add('hw-enhanced');
      const observer = new IntersectionObserver(entries => entries.forEach(entry=>{
        if(entry.isIntersecting){entry.target.classList.add('hw-visible');observer.unobserve(entry.target);}
      }),{threshold:.08,rootMargin:'0px 0px -30px 0px'});
      root.querySelectorAll('[data-hw-reveal]').forEach(el=>observer.observe(el));
    }
    update();
  };
  document.querySelectorAll('[data-hw-belgrave]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-hw-belgrave]').forEach(init));
})();

